import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  block-size: ${spacing(0.375)};
  border-radius: ${spacing(1)};
  position: relative;
  background: color-mix(in srgb, ${cssTheme.default.day.text} 30%, transparent);
  overflow: hidden;
`

export const inner = css`
  position: absolute;
  block-size: 100%;
  inline-size: 0;
  top: 0;
  left: 0;
  background: ${cssTheme.default.day.text};
`

export const loading = css`
  animation: loading 10s linear forwards;

  @keyframes loading {
    0% {
      inline-size: 0;
    }
    100% {
      inline-size: 100%;
    }
  }
`

export const loaded = css`
  inline-size: 100%;
`
